module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cer-box"
  }, [_c('el-form', {
    attrs: {
      "model": _vm.creInfo,
      "label-width": "150px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "col-right",
    attrs: {
      "span": 4
    }
  }, [_vm._v("Shopex通行证书")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "通行证账号："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.creInfo.cert_id),
      callback: function($$v) {
        _vm.$set(_vm.creInfo, "cert_id", $$v)
      },
      expression: "creInfo.cert_id"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "col-right",
    attrs: {
      "span": 4
    }
  }, [_vm._v("Shopex证书")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "当前证书节点号："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.creInfo.node_id),
      callback: function($$v) {
        _vm.$set(_vm.creInfo, "node_id", $$v)
      },
      expression: "creInfo.node_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "当前证书节点号："
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.creInfo.shopex_uid),
      callback: function($$v) {
        _vm.$set(_vm.creInfo, "shopex_uid", _vm._n($$v))
      },
      expression: "creInfo.shopex_uid"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4,
      "offset": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.deleteCer
    }
  }, [_vm._v("删除证书")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "cer-box"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "col-right",
    attrs: {
      "span": 4
    }
  }, [_vm._v("电商ERP关系绑定")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "offset": 1
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.bindRelation
    }
  }, [_vm._v("申请绑定")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.lookRelation
    }
  }, [_vm._v("查看绑定关系")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "申请绑定",
      "visible": _vm.dialogBindVisible,
      "fullscreen": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogBindVisible = $event
      }
    }
  }, [_c('div', [_c('iframe', {
    attrs: {
      "src": _vm.bindUrl,
      "width": "1200",
      "height": "980",
      "frameborder": "0",
      "scrolling": "auto"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogBindVisible = false
      }
    }
  }, [_vm._v("关 闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看绑定关系",
      "visible": _vm.dialogLookVisible,
      "fullscreen": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogLookVisible = $event
      }
    }
  }, [_c('div', [_c('iframe', {
    attrs: {
      "src": _vm.lookUrl,
      "width": "1200",
      "height": "980",
      "frameborder": "0",
      "scrolling": "auto"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogLookVisible = false
      }
    }
  }, [_vm._v("关 闭")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-63f728e0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63f728e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/setting/certificate/index.vue
// module id = 2780
// module chunks = 0